module.exports = __webpack_public_path__ + "static/img/badulina.7bcc90d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badulina.jpg
// module id = 184
// module chunks = 1